import { render } from "./OrderComplete.vue?vue&type=template&id=36befb43&scoped=true"
import script from "./OrderComplete.vue?vue&type=script&lang=js"
export * from "./OrderComplete.vue?vue&type=script&lang=js"

import "./OrderComplete.vue?vue&type=style&index=0&id=36befb43&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36befb43"]])

export default __exports__